<div class="container">
  <div class="alert alert-danger" *ngIf="errorMessage !== ''">
    <strong>Error!</strong> {{errorMessage}}
  </div>

  <div class="col-12 text-center"><img src="../../../assets/images/emblem.png" class="emblem" /></div>

  <br />
  <form class="row" #contactForm="ngForm" (ngSubmit)="submitContact(contactForm.form);" validate>
    <div class="col-md-6">
      <div class="col-md-12"><span class="form-title required">FIRST NAME</span><br /><input type="text" class="form-control" id="name" name="name" ngModel #nameField="ngModel" required maxlength="100"></div>
      <div class="col-md-12"><span class="form-title required">LAST NAME</span><br /><input type="text" class="form-control" name="surname" ngModel #nameField="ngModel" required maxlength="100"></div>
      <div class="col-md-12"><span class="form-title required">PREFIX</span><br /><input type="text" class="form-control" name="prefix" ngModel #nameField="ngModel" required maxlength="10"></div>
      <div class="col-md-12"><span class="form-title required">MOBILE NO</span><br /><input type="text" class="form-control" name="mobile" ngModel #nameField="ngModel" pattern="^(0|[1-9][0-9]*)$" required maxlength="20"></div>
      <div class="col-md-12"><span class="form-title required">EMAIL</span><br /><input type="email" class="form-control" name="email" ngModel #nameField="ngModel" required email maxlength="200"></div>
      <div class="col-md-12"><span class="form-title required">MESSAGE</span><br /><textarea class="form-control" rows="5" name="message" ngModel #nameField="ngModel" required maxlength="500"></textarea></div>
  
      <!-- <div class="col-md-12"><re-captcha ngModel #nameField="ngModel" name="captcha" required siteKey="6LeNgU0UAAAAAGgUC5QXA-VHzyeC4E0f5mUg7FEB"></re-captcha></div> -->
  
      <div class="error col-md-12" *ngIf="formSubmit && !contactForm.valid">
          Please input all required fields.
      </div>
      <div class="col-md-12"><button class="col-md-6 mx-auto btn btn-default" (click)="formSubmit=true">CONTACT US NOW</button></div>
    </div>

    <div class="col-md-6 text-center" style="margin-top:20px">
      <h3>Management & Booking</h3>
      <p>Shawn Mizzi<br />shawnmizzi@gmail.com</p>
      <br />
      <h3>Band Contact</h3>
      <p>angelcryptband@gmail.com</p>
      <!-- <br />
      <h3>Booking Agent</h3>
      <p>lalchimieagency@gmail.com</p> -->
    </div>
  </form>
</div>